<template>
  <article class="interview-contents">
    <InterviewImage :image-src="require('@/assets/lp/mcs_robo.png')" :image-art="'木下の介護インタビュー画像2'"/>
    <InterviewQAndA>
      <template v-slot:question>ーHRモンスターの導入前の外国人採用の状況はいかがでしたか。</template>
      <template v-slot:answer>
        （矢澤様）うちはホームページに日本人向けの応募フォームしかなかったので、外国の方からはメッセージ機能のように使われていました。<br>
        応募のフォームではあるのですが、そこでご自分の希望等をお伝えくださる、ということが多かったです。<br>
        <br>
        （高橋様）
        ちょうどHRモンスターを入れる前くらいが、外国人の方向けの記事をホームページに設置したこともあり、その記事を読んだ方たちの問い合わせが当時すごく多かったので、当時は手が回っていませんでした。
      </template>
    </InterviewQAndA>
    <InterviewQAndA>
      <template v-slot:question>ーHRモンスターを知ったきっかけは何でしたか。</template>
      <template v-slot:answer>
        （高橋様）記事を見た外国の方からの問い合わせについて、電話で対応していくというよりもチャットボットである程度フィルターを掛けてあっていこうと思っていました。<br>
        そのときにちょうど社内の方からHRモンスターを紹介していただいて、使ってみようかなと思いました。
      </template>
    </InterviewQAndA>
    <InterviewQAndA>
      <template v-slot:question>ー実際にHRモンスターの画面などを見た際、どのような印象を受けましたか。</template>
      <template v-slot:answer>
        （高橋様）操作は非常にしやすかったです。ただ、チャットボットの入り口のアイコンに可愛げが無い・・・（笑）<br>
        <br>
        （矢澤様）私は逆に、奇抜だなと思ったので、それはそれで目立ってよいのかなと思いました。<br>
        名前もみんなすぐに覚えましたし、モンスターとか画面とか、採用系のものにしては変わっているなっていうのは率直に思いましたけど、個性があっていいと思いました（笑）
      </template>
    </InterviewQAndA>
    <InterviewImage :image-src="require('@/assets/lp/mcs_oubo.jpg')" :image-art="'木下の介護インタビュー画像2'"/>
    <InterviewQAndA>
      <template v-slot:question>ー導入の決め手といった部分は何でしたでしょうか。</template>
      <template v-slot:answer>
        （高橋様）最初にお試して使わせてくれるっていうところですかね。（笑）<br>
        本格導入の決め手としては、色々と改善していってくれるという期待度が高かったです。<br>
        導入時点で満足していたかというとそうではないですが、そこからのブラッシュアップが期待度が高いです。<br>
        でも、使いやすかったですよ。最初の設定とか、操作しやすかったです。
      </template>
    </InterviewQAndA>
    <InterviewQAndA>
      <template v-slot:question>ー外国人の方を受け付けるロボについて、以前は連絡が繋がらない方が多かったという部分は、その後いかがですか？</template>
      <template v-slot:answer>
        （矢澤様）以前よりも連絡が繋がる方が増えたと感じています。<br>
        外国の方に認知していただく際には、広告なんかもお金を掛けて行っていたので、その後のコンタクトという部分でHRモンスターが受け皿としてあることで皆さん気軽にご連絡をいただけるようになったと思います。<br>
        現在はスクリーニングの仕組みも加えたので、応募数といった部分で数字が減ってはいるのですが、その分、連絡が繋がらない、対応ができないといった方の対応をしなくて済んでいると思っています。<br>
      </template>
    </InterviewQAndA>
    <InterviewImage :image-src="require('@/assets/lp/mcs_story.jpg')" :image-art="'木下の介護インタビュー画像2'"/>
    <InterviewQAndA>
      <template v-slot:question>ー導入いただいてから、実際の使い心はいかがですか？</template>
      <template v-slot:answer>
        （高橋様）いろいろな機能を提案してくれて、面白いです。今、一番期待しているのはノベルの部分ですかね。<br>
        あれはチャットボットの延長線だと思っているので、機能としてはうまくハマってくれれば良いなと思っています。<br>
        <br>
        （矢澤様）チャットボットは口語調の話している感覚で進んでいくし、聞きたいと思っているであろう点を全体的にお伝えできるので、結構情報量があると思っています。<br>
        その中で会社の雰囲気もわかっていただけるので、凄く良いなと思っています。<br>
        広報という部分でも、HRモンスターには期待をさせていただいている部分が大きいです。
      </template>
    </InterviewQAndA>
    <InterviewQAndA>
      <template v-slot:question>ー今後のHRモンスターについて、期待する部分は？</template>
      <template v-slot:answer>
        （高橋様）「電話対応と言った部分でも、チャットボットとして使えます」となってくると凄くありがたいかなぁと。<br>
        時間帯によって回答が切り替わるとか、特に自分たちが使いやすいと感じるような機能があると良いなと思います。<br>
        <br>
        （矢澤様）ショートメールにURLが飛んでいく部分を丁寧にできたり、「時間外なのでこちらのショートメールで答えてくださいね」というようなところができたりすると助かります。
      </template>
    </InterviewQAndA>
    <div class="newspaper-img-wrapeer">
      <img src="@/assets/lp/mcs_taidan.png" alt="">
      <p>※高齢者住宅新聞社様にて、メディカル・ケア・サービス 高橋様との対談の様子を掲載。ICT活用の一つとしてHRモンスターをご活用いただいております。</p>
    </div>
  </article>
</template>

<script>
import InterviewImage from '@/components/LP/atoms/InterviewImage'
import InterviewQAndA from '@/components/LP/molecules/InterviewQAndA'

export default {
	components: {
    InterviewImage,
    InterviewQAndA
	}
}
</script>

<style scoped lang="scss">
.interview-contents {
  margin: auto;
  > * {
    margin-top: 80px;
  }
}
.newspaper-img-wrapeer {
  max-width: 560px;
  margin: auto;
  margin-top: 80px;
}

@media screen and (max-width: 480px) {
  .interview-contents {
    > * {
      margin-top: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/organisms/MCSInterviewContents.vue